<template>
  <div>
    <nav id="navbar-main" class="navbar navbar-main navbar-expand-lg navbar-dark navbar-theme-primary" style="padding-bottom: 0.8rem !important;padding-top: 0.8rem !important;">
      <div style="width:100%;display: flex;flex-wrap: wrap;align-items: center;justify-content: space-between;">
        <router-link to="/dashboard/" class="navbar-brand @@logo_classes" style="border-bottom: 0px;background: transparent;">
          <div class="d-flex align-items-center">
            <img src="/logo/logo-title-white.png" style="max-width:135px;" alt="Logo QR.io">
          </div>
        </router-link>
        <div v-show="propsdata[0].cargado">
          <div class="fiumfiummcqueen d-md-block" style="display:none;">
            <!-- UPGRADE - ON FREE TRIAL -->
            <a v-if="propsdata[0].freetrial === 'yes'" :href="'/choose-plan/'+propsdata[0].unique_id+'?utm_campaign=dashboard_on_trial'" class="btn btn-md btn-white animate-up-2" style="color: #000000;">
              <i class="fas fa-crown mr-1" style="color: #f4bd00;"></i>
              {{propsdata[0]['translation']['header-upgrade-button']}}
            </a>
            <!-- UPGRADE - TRIAL EXPIRED -->
            <a v-if="propsdata[0].paid !== 'yes' && propsdata[0].freetrial !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes'" :href="'/choose-plan/'+propsdata[0].unique_id+'?utm_campaign=dashboard_trial_expired'" class="btn btn-md btn-white animate-up-2" style="color: #000000;">
              <i class="fas fa-crown mr-1" style="color: #f4bd00;"></i>
              {{propsdata[0]['translation']['header-upgrade-button']}}
            </a>
            <!-- PREMIUM -->
            <a v-if="propsdata[0].paid === 'yes'" class="btn btn-md btn-white" style="color: #f4bd00;background-color: #ffffff;border-color: #f4bd00;cursor:initial;">
              <i class="fas fa-crown mr-1" style="color: #f4bd00;"></i>
              {{propsdata[0]['translation']['header-premium-button']}}
            </a>
            <div class="dropdown mb-lg-0" style="display: inline-block;padding: 0 0 0 20px;">
              <a id="confDropdown_desktop" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-toggle footer-language-link pb-2" style="color: #fff;">
                {{propsdata[0].email}} <i class="fas fa-chevron-down ml-1"></i>
              </a>
              <div aria-labelledby="confDropdown_desktop" class="dropdown-menu dropdown-menu-center mt-0" style="left: unset!important;right:0;">
                <a :href="propsdata[0]['translation']['header-home-url']" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-home mr-2"></i> {{propsdata[0]['translation']['header-home']}}</a>
                <router-link to="/dashboard/" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-qrcode mr-2"></i> {{propsdata[0]['translation']['header-dashboard']}}</router-link>
                <router-link to="/dashboard/account" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-cog mr-2"></i> {{propsdata[0]['translation']['header-account-settings']}}</router-link>
                <router-link to="/dashboard/billing" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-file-alt mr-2"></i> {{propsdata[0]['translation']['header-billing']}}</router-link>
                <a :href="propsdata[0]['translation']['header-api-url']" target="_blank" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-bezier-curve mr-2"></i> {{propsdata[0]['translation']['header-api']}}</a>
                <a :href="propsdata[0]['translation']['header-contact-url']" target="_blank" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-inbox mr-2"></i> {{propsdata[0]['translation']['header-contact']}}</a>
                <a href="https://help.qr.io/en/" target="_blank" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-question-circle mr-2"></i> {{propsdata[0]['translation']['header-help-center']}}</a>
                <a href="/logout" class="dropdown-item text-sm"><i class="fas fa-sign-out-alt mr-2"></i> {{propsdata[0]['translation']['header-log-out']}}</a>
              </div>
            </div>
          </div>
          <div class="d-md-none">
            <div class="d-flex">
              <!-- SETTINGS -->
              <div class="dropdown mb-lg-0">
                <button class="btn btn-md btn-white py-1 px-2 dropdown-toggle" id="confDropdown_mobile" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fas fa-cog"></i>
                </button>
                <div aria-labelledby="confDropdown_mobile" class="dropdown-menu dropdown-menu-center mt-0" style="left: unset!important;right:0;">
                  <a :href="propsdata[0]['translation']['header-home-url']" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-home mr-2"></i> {{propsdata[0]['translation']['header-home']}}</a>
                  <router-link to="/dashboard/" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-qrcode mr-2"></i> {{propsdata[0]['translation']['header-dashboard']}}</router-link>
                  <router-link to="/dashboard/account" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-cog mr-2"></i> {{propsdata[0]['translation']['header-account-settings']}}</router-link>
                  <router-link to="/dashboard/billing" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-file-alt mr-2"></i> {{propsdata[0]['translation']['header-billing']}}</router-link>
                  <a :href="propsdata[0]['translation']['header-api-url']" target="_blank" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-bezier-curve mr-2"></i> {{propsdata[0]['translation']['header-api']}}</a>
                  <a :href="propsdata[0]['translation']['header-contact-url']" target="_blank" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-inbox mr-2"></i> {{propsdata[0]['translation']['header-contact']}}</a>
                  <a href="https://help.qr.io/en/" target="_blank" class="dropdown-item text-sm" style="border-bottom: none;"><i class="fas fa-question-circle mr-2"></i> {{propsdata[0]['translation']['header-help-center']}}</a>
                  <a href="/logout" class="dropdown-item text-sm"><i class="fas fa-sign-out-alt mr-2"></i> {{propsdata[0]['translation']['header-log-out']}}</a>
                </div>
              </div>
              <!-- SIDEBAR -->
              <div v-if="propsdata[0].path === '/dashboard/' || 
                    propsdata[0].path === '/dashboard/archived' || 
                    propsdata[0].path === '/dashboard/api-qr-codes' || 
                    propsdata[0].path === '/dashboard/general-stats' || 
                    propsdata[0].path === '/dashboard/saved-designs' || 
                    propsdata[0].path.includes('/dashboard/folder/')" 
                    class="d-md-none">
                <button @click="$emit('togglesidebar')" class="btn btn-md btn-white py-1 px-2 ml-2">
                  <i class="fas fa-bars"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<style>
  .router-link-exact-active{
    background: #f3f5f9;
    color: #3e4555!important;
  }
  .router-link-exact-active:hover{
    background: #f3f5f9;
    color: #3e4555!important;
  }
  a {
    color: #3e4555;
  }
  .jwoEpG {
    display: block;
    width: 100%;
    background-color: rgb(242, 245, 250);
    padding: 100px 20px 0px 20px;
  }
  @media (max-width: 767px){
    .jwoEpG {
      padding: 20px 0px 20px 0px;
    }
  }
  .preload:before{
    content:"";
    position:absolute;
    top:0;
    bottom:0;
    left:0;
    right:0;
    display:block;
    background:linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.5),hsla(0,0%,100%,0));
    -webkit-animation:_1IOU .8s linear infinite;
    animation:_1IOU .8s linear infinite
  }
  @-webkit-keyframes _1IOU{
    0%{
      -webkit-transform:translateX(-100%);
      transform:translateX(-100%)
    }
    to{
      -webkit-transform:translateX(100%);
      transform:translateX(100%)
    }
  }
  @keyframes _1IOU{
    0%{
      -webkit-transform:translateX(-100%);
      transform:translateX(-100%)
    }
    to{
      -webkit-transform:translateX(100%);
      transform:translateX(100%)
    }
  }
</style>

<script>
  export default {
    props:['propsdata'],
  }
</script>



// WEBPACK FOOTER //
// src/Header.vue